import React from "react"
import propTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import NewBillingForm from "./modalNewBilling/NewBillingForm"

const ModalNewBilling = ({ isOpen, toggle }) => {
  // Componente modal para crear una nueva factura
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="xl" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Nueva Factura
      </ModalHeader>
      <ModalBody>
        <NewBillingForm toggle={toggle} />
      </ModalBody>
    </Modal>
  )
}

ModalNewBilling.propTypes = {
  isOpen: propTypes.bool,
  toggle: propTypes.func,
}

export default ModalNewBilling